import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { NavButtonScrollType, NavigationType } from '../../services';

/** TODO: не используется */
@Component({
  selector: 'lp-nav-button',
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavButtonComponent {
  @Input() type: NavButtonScrollType = 'forward-bottom';
  @Input() variant: NavigationType = 'horizontal';
  @Input() visible = true;

  @Output() scrollPanel = new EventEmitter<NavButtonScrollType>();

  get icon() {
    if (this.type === 'backward-top') {
      return this.variant === 'horizontal' ? '@tui.chevron-left' : '@tui.chevron-up';
    } else {
      return this.variant === 'horizontal' ? '@tui.chevron-right' : '@tui.chevron-down';
    }
  }
}
